import { render, staticRenderFns } from "./TouchpointStatisticsOverviewRow.vue?vue&type=template&id=18328878&scoped=true&"
import script from "./TouchpointStatisticsOverviewRow.vue?vue&type=script&lang=js&"
export * from "./TouchpointStatisticsOverviewRow.vue?vue&type=script&lang=js&"
import style0 from "./TouchpointStatisticsOverviewRow.vue?vue&type=style&index=0&id=18328878&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18328878",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Data\\TeamCity\\buildAgent\\work\\6dffdb6616650f37\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18328878')) {
      api.createRecord('18328878', component.options)
    } else {
      api.reload('18328878', component.options)
    }
    module.hot.accept("./TouchpointStatisticsOverviewRow.vue?vue&type=template&id=18328878&scoped=true&", function () {
      api.rerender('18328878', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/CanvasArea/Bricks/TouchpointOverview/Statistics/TouchpointStatisticsOverviewRow.vue"
export default component.exports